module.exports = __webpack_public_path__ + "media/images/icon__checkmark--white@3x-eea15c08dc5cc807c54c1b3243884913.png";